const locale = state => state.locale
const isLogged = state => state.userEmail != null
const email = state => state.userEmail
const userEmail = state => state.userEmail
const userId = state => state.userId || ''
const rol = state => state.rol
const companyName = state => state.companyName || ''
const parentRef = state => state.parentRef || process.env.VUE_APP_PARENT_REF
const jobPosition = state => state.jobPosition || ''
const city = state => state.city || ''
const country = state => state.country || ''
const userAvatar = state => state.userAvatar || ''
const socialNetwork = state => state.socialNetwork || ''
const telephone = state => state.telephone || ''
const name = state => `${state.userFirstName || ''} ${state.userLastName || ''}`
const deposit = state => state.deposit || false
const admissionsComittee = state => state.admissionsComittee || false
const kycInformation = state => state.kycInformation || false
const ndaDraft = state => state.ndaDraft || false
const contractDraft = state => state.contractDraft || false
const signedNDA = state => state.signedNDA || null
const admissionDate = state => state.admissionDate || null
const signedContract = state => state.signedContract || null
const kyc = state => state.kyc || null

const personalData = state => {
  return {
    userAvatar: state.userAvatar || '',
    userFirstName: state.userFirstName || '',
    userLastName: state.userLastName || '',
    jobPosition: state.jobPosition || '',
    socialNetwork: state.socialNetwork || '',
    telephone: state.telephone || '',
    parentRef: state.parentRef || '',
    city: state.city || '',
    lang: state.locale || 'en',
    country: state.country || ''
  }
}

const subscriptionData = state => {
  return {
    deposit: state.deposit || false,
    kycInformation: state.kycInformation || false,
    kyc: state.kyc || false,
    admissionsComittee: state.admissionsComittee || false,
    admissionDate: state.admissionDate || false,
    ndaDraft: state.ndaDraft || false,
    signedNDA: state.signedNDA || false,
    contractDraft: state.contractDraft || false,
    signedContract: state.signedContract || false,
    subscription: state.subscription || false,
    expirationDate: state.expirationDate || false
  }
}

export default {
  userEmail,
  userId,
  locale,
  isLogged,
  email,
  name,
  companyName,
  jobPosition,
  city,
  parentRef,
  country,
  userAvatar,
  telephone,
  rol,
  socialNetwork,
  personalData,
  deposit,
  admissionsComittee,
  kycInformation,
  ndaDraft,
  contractDraft,
  signedNDA,
  admissionDate,
  signedContract,
  kyc,
  subscriptionData
}
